import { render, staticRenderFns } from "./CardUpdatableCUSPLFSMSPRO.vue?vue&type=template&id=21825408&scoped=true&"
import script from "./CardUpdatableCUSPLFSMSPRO.vue?vue&type=script&lang=js&"
export * from "./CardUpdatableCUSPLFSMSPRO.vue?vue&type=script&lang=js&"
import style0 from "./CardUpdatableCUSPLFSMSPRO.vue?vue&type=style&index=0&id=21825408&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21825408",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VChip,VCol,VContainer,VDialog,VListItemContent,VListItemTitle,VRow,VSelect,VSwitch,VTextField})
